import React from 'react'
import { DecimalInput } from './style'

function Decimal({ ...props }) {
  return <DecimalInput decimalSeparator=',' thousandSeparator='.' decimalScale={2} fixedDecimalScale {...props} />
}

export default Decimal
